import React, {Component} from 'react';
import {Bar, BarChart, Brush, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import * as dataService from "../service/data-info-chart/requestsUtil";
import {COLORS, GRAPH_MARGIN, INCOME_DISCOUNTS, WHITOUT_INFORMATION} from "../utils/constants";
import * as cbu from "../utils/checkBusinessUnit";
import * as formatter from "../utils/formatters"

var Loader = require('react-loader');

class IncomeDiscount extends Component {

  constructor(props) {
    super(props);
    this.state = {datas: [], loaded: false, date: this.props.date};
  }

  componentDidMount() {
    let params = {
      id: cbu.checkBusinessUnit(this.props.bu),
      date: this.state.date
    }

    dataService.postFetch(INCOME_DISCOUNTS, params)
      .then((data) => {
        this.setState({datas: data, loaded: true});
      });
  }

  componentWillReceiveProps(nextProps) {
    let params = {
      id: cbu.checkBusinessUnit(this.props.bu),
      date: this.props.date
    }

    dataService.postFetch(INCOME_DISCOUNTS, params)
      .then((data) => {
        this.setState({datas: data, loaded: true, date: nextProps.date});
      });
  }

  render() {
    if (this.state.datas.length > 0) {
      return (
        <Loader top={'90%'} loaded={this.state.loaded}>
          <ResponsiveContainer>
            <BarChart width={600} height={300} data={this.state.datas}
                      margin={GRAPH_MARGIN}>
              <XAxis dataKey="month"/>
              <YAxis tickFormatter={formatter.formatNumber} scale={'linear'}/>
              <CartesianGrid/>
              <Tooltip formatter={formatter.formatNumberMoney}/>
              <Legend verticalAlign={"top"}/>
              <Bar name={"Ingreso"} dataKey="amount" stackId="a" fill={COLORS.AMOUNT}/>
              <Bar name={"Descuento"} dataKey="discount" stackId="a" fill={COLORS.BASE}/>
              <Brush dataKey={"mes"} height={20}/>
            </BarChart>
          </ResponsiveContainer>
        </Loader>
      );
    } else {
      return (
        <Loader loaded={this.state.loaded} top="50%"><h2
          className="without-avilable-information">{WHITOUT_INFORMATION}</h2></Loader>);
    }
  }
}

export default IncomeDiscount





// WEBPACK FOOTER //
// ./src/charts/incomeDiscount.js